import { FormattedMessage } from 'react-intl';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingPanel = props => {
  const { message } = props;

  return createPortal(
    <div className="global-loading-panel">
      <div className="panel-wrapper">
        <div
          style={{
            width: 200,
            height: 200,
            margin: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress size={80} />
        </div>
        <div className="panel-message">
          {message || <FormattedMessage defaultMessage="Please Wait" />}
        </div>
      </div>
    </div>,
    document.body,
  );
};

LoadingPanel.propTypes = {
  message: PropTypes.string,
};

export default LoadingPanel;
